<template>
  <div class="setting-group" :class="{ open: isOpen }">
    <div class="tit-wrap">
      <h1 class="tit">{{ title }}</h1>
      <button type="button" class="fold-btn" @click="toggleButton">
        <IconArrow></IconArrow>
      </button>
    </div>

    <div class="inr">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';

withDefaults(
  defineProps<{
    title: string;
  }>(),
  {
    title: '',
  }
);

const isOpen = defineModel<boolean>('is-open', { default: false });

const toggleButton = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped lang="scss">
.setting-group {
  max-height: 26px;
  overflow: hidden;
  transition: all 0.4s ease;
  &.open {
    max-height: 700px;
    .tit-wrap {
      .fold-btn {
        svg {
          transform: rotate(0);
        }
      }
    }
  }
  .tit-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tit {
      font-size: $font-size-l;
    }
    .fold-btn {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .inr {
    padding-top: 1.5rem;
    p {
      font-size: $font-size-psmall;
      padding-right: $size-s;
    }
    &.keyword {
      .keyword-btn {
        padding: 0;
        justify-content: space-between;
        margin-bottom: $size-m;
        svg {
          transform: rotate(90deg);
        }
      }
      .kw-input-wrap {
        display: flex;
        justify-content: space-between;
        gap: $size-s;
        .gray-btn {
          max-width: 4rem;
        }
      }
      .chips-wrap {
        margin-top: $size-m;
        p {
          font-weight: 600;
          margin-bottom: $size-s;
        }
        .lang-chip-item {
          border: 1px solid $color-gray-40;
          padding: $size-m;
          border-radius: $size-s;
          margin-bottom: $size-s;
          &:last-child {
            margin-bottom: 0;
          }
          .chip-list {
            display: flex;
            flex-wrap: wrap;
            gap: $size-xs;
            li {
              background: $color-gray-40;
              display: inline-block;
              padding: 0.25rem 0.25rem 0.25rem 0.5rem;
              border-radius: $size-s;
              width: auto;
              span {
                font-size: $font-size-psmall;
                vertical-align: 2px;
                line-height: 130%;
                white-space: nowrap;
              }
              button {
                padding: 0.25rem;
              }
            }
          }
        }
      }
    }
    &.image {
      .image-change-item {
        text-align: center;
        p {
          font-weight: 500;
        }
        .img-file-wrap {
          position: relative;
          width: 8.75rem;
          margin: 1.25rem auto 0.75rem;
          .box-in {
            width: 100%;
            aspect-ratio: 1/1;
            background: $gray10;
            border-radius: 2.5rem;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .img-add-btn {
            position: absolute;
            right: 0;
            bottom: -0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 2.5rem;
            padding: 0;
            border-radius: 50%;
            aspect-ratio: 1/1;
            background: $color-gray-700;
          }
        }
        span {
          font-size: $font-size-xs;
        }
        &:not(:first-child) {
          padding-top: 2rem;
          margin-top: 2rem;
          border-top: 1px solid $color-gray-40;
        }
      }
    }
  }
}

.fold-btn {
  padding: 0;
  svg {
    width: 1.5rem;
    height: 1.5rem;
    transition: all 0.4s ease;
  }
}
</style>
